// PricingPage.jsx
import React from 'react';
import { CiCircleCheck as CheckIcon } from 'react-icons/ci';
import { useLocation, useNavigate } from 'react-router';

import './index.css';
import HeaderComponent from '../../components/Header';
import PricingFaq from './PricingFaq';
import { Switch } from 'antd';
import { createOrder, verifyOrder } from '../../components/PricingComponenet';
import { PiCurrencyInr } from 'react-icons/pi';
import { useDispatch, useSelector } from 'react-redux';
import { showSnack } from 'react-redux-snackbar';
import { verifyToken } from '../../redux/actions';
import ConnectWitTeam from '../NewLandingDesign/connect';
import LandingScreenFooter from '../../components/LandingFooter';
import FooterNew from '../../components/FooterNew';

const tiers = [
	{
		name: 'Starter',
		alias: 'starter',
		price: [0, 0],
		mrpPrice: [699, 599],
		billing: 'per month',
		description: 'Perfect for side projects and small businesses',
		features: [
			'Free upto 100 Assets',
			'Upto 5 Admins',
			'Bulk upload',
			'Unlimited Custom fields',
			'Custom Asset tag / QR code, barcode generation',
			'HRMS  Integrations',
			'Email & Slack Notifications',
			'Activity Info',
			'User & Roles Configuration',
		],
		buttonText: 'Get Started',
		highlighted: false,
	},
	{
		name: 'Pro',
		alias: 'pro',
		billing: 'per month',
		description: 'Best for growing companies',
		features: [
			'Upto 500 Assets',
			'Weekly Reporting',
			'Mobile App for seamless asset tracking',
			'Unlimited Admins',
			'Asset audit for Physical verification',
			'Email based support',
			'Asset Lifecycle Tracking',
		],
		price: [1599, 1299], // 137 * 12 = 1644
		mrpPrice: [1599, 1299],
		buttonText: 'Get Started',
		highlighted: false,
	},
	{
		name: 'Enterprise',
		alias: 'enterprise',
		price: '99',
		billing: 'per month',
		description: 'For large organizations',
		features: [
			'Custom Reporting',
			'Email and phone based support',
			'Assisted Onboarding/ Project Implementation',
			'Schedule Asset Maintenance',
		],
		buttonText: 'Get Started',
		highlighted: false,
		isCustomPrice: true,
	},
];

const PricingPage = () => {
	const loggedIn = useSelector((state) => state.appreducer.loggedIn);
	const [checked, setChecked] = React.useState(true);
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	console.log(location.search, 'location.search');

	React.useEffect(() => {
		function checkOrder() {
			const id = new URLSearchParams(location.search).get('order_id');
			if (id) {
				verifyOrder(id, navigate, dispatch);
			}
		}
		checkOrder();
	}, [location.search]);

	const onChange = (el) => {
		console.log('switch');
		setChecked(el);
	};

	const submitRequest = async (tier) => {
		try {
			if (loggedIn) {
				const resp = await createOrder(tier.alias, !checked ? 'monthly' : 'annual', navigate, dispatch);
				if (resp.type === 'error') {
					return dispatch(showSnack('CREATE_ORDER_FAILED', { label: resp.error, timeout: 7000 }));
				}
				if (resp.code === 'REACHOUT_CREATED') {
					dispatch(
						showSnack('CREATE_ORDER_REACHOUT_CREATED', {
							label: 'Our team will connect with you to understand the exact requirements',
							timeout: 7000,
						})
					);
				}
			} else {
				navigate('/register-init');
			}
		} catch (e) {
			console.error(e);
		}
	};

	return (
		<div>
			<HeaderComponent />
			<div className="pricing-page-container">
				<div className="mx-auto max-w-7xl px-6 lg:px-8">
					<div className="mx-auto max-w-4xl text-center">
						<h2 className="text-base font-semibold leading-7 text-indigo-600">Pricing</h2>
						<p className="pricing-head2">
							Simple, transparent pricing that grows with you. Try any plan free for 30 days.
						</p>
					</div>

					<div className="price-time-selector">
						<div className="time">
							Pay <br /> Monthly
						</div>
						<Switch checked={checked} defaultChecked onChange={onChange} />
						<div className="time same-row">
							<div>
								Pay <br /> Annually
							</div>
							<div className="save-tag">Save 20%</div>
						</div>
					</div>

					<div className="pricing-tiers-container">
						{tiers.map((tier) => {
							const price = tier.isCustomPrice ? 0 : checked ? tier.price[1] : tier.price[0];
							const isOfferExist = tier.isCustomPrice
								? 0
								: checked
								? tier.price[1] != tier.mrpPrice[1]
								: tier.price[0] != tier.mrpPrice[0];

							const mrpPrice = tier.isCustomPrice ? 0 : checked ? tier.mrpPrice[1] : tier.mrpPrice[0];
							return (
								<div key={tier.name} className={`each-tier ${tier.highlighted ? '' : ''} `}>
									<h3
										className={`text-lg font-semibold leading-8 ${
											tier.highlighted ? 'text-white' : 'text-gray-900'
										}`}
									>
										{tier.name}
									</h3>
									<p
										className={`mt-4 text-sm leading-6 ${
											tier.highlighted ? 'text-indigo-100' : 'text-gray-600'
										}`}
									>
										{tier.description}
									</p>
									{!tier.isCustomPrice ? (
										<p className="mt-6 flex items-baseline gap-x-1">
											<b>
												<span
													className={`text-4xl font-bold tracking-tight ${
														tier.highlighted ? 'text-white' : 'text-gray-900'
													}`}
												>
													<PiCurrencyInr size={13} style={{ fontWeight: 'bold' }} />
													{isOfferExist ? (
														<span>
															<span
																style={{ textDecoration: 'line-through', color: 'red' }}
															>
																{mrpPrice}
															</span>
															{'   '}
														</span>
													) : null}
													{price}{' '}
												</span>
												<span
													className={`text-sm font-semibold leading-6 ${
														tier.highlighted ? 'text-indigo-100' : 'text-gray-600'
													}`}
												>
													{tier.billing}
												</span>
											</b>
										</p>
									) : null}

									<ul
										className={`mt-8 space-y-3 text-sm leading-6 ${
											tier.highlighted ? 'text-indigo-100' : 'text-gray-600'
										}`}
										style={{ paddingLeft: '0px' }}
									>
										{tier.features.map((feature) => (
											<li
												style={{
													listStyle: 'none',
													display: 'flex',
													alignItems: 'center',
													// justifyContent: 'center',
													marginBottom: '5px',
												}}
												key={feature}
												className="flex gap-x-3"
											>
												<span style={{ minWidth: '30px' }}>
													<CheckIcon
														className={`h-6 w-5 flex-none ${
															tier.highlighted ? 'text-white' : 'text-indigo-600'
														}`}
														aria-hidden="true"
													/>
												</span>
												<span>{feature}</span>
											</li>
										))}
									</ul>
									<button
										onClick={() => {
											submitRequest(tier);
										}}
										className={`button-action`}
									>
										{tier.buttonText}
									</button>
								</div>
							);
						})}
					</div>
				</div>
			</div>
			<PricingFaq />
			<div style={{ marginTop: '50px' }}></div>
			{/* <ConnectWitTeam /> */}
			<FooterNew />
		</div>
	);
};

export default PricingPage;
